import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  signInForm: {
    maxWidth: theme.spacing(74),
    width: '100%',
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
  },
  signInHeader: {
    alignSelf: 'flex-start',
    '& > div:nth-child(even)': {
      marginTop: theme.spacing(1),
    },
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  showPasswordButton: {
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

export default useStyles;
